<ngb-pagination *ngIf="totalElements > pageSize" (pageChange)="changePage($event)" [page]="pageNumber + 1" [pageSize]="pageSize" [collectionSize]="totalElements" [maxSize]="5">
    <ng-template ngbPaginationPrevious>
        <fa-icon [icon]="['fas', 'arrow-left']" class="pe-4"></fa-icon>
    </ng-template>
    <ng-template ngbPaginationNext>
        <fa-icon [icon]="['fas', 'arrow-right']" class="ps-4"></fa-icon>
    </ng-template>
</ngb-pagination>
